<template>
    <div
        v-if="selfieAnalysis && selfieAnalysis.selfieAnalysisEnabled"
        class="bg-ds-primary-50 px-4 py-2"
    >
        <div class="text-sm font-bold text-ds-primary-700">Selfie Check</div>
        <div class="flex justify-start gap-5 pt-1 text-xs font-normal xs:flex-col md:flex-row">
            <div class="flex-1 flex-col">
                <div>Did the client provide a proper selfie?</div>
                <CheckStateResult
                    class="font-semibold"
                    :value="selfieAnalysis.isSelfieProvided"
                />
            </div>
            <div class="flex-1 flex-col">
                <div>Are the selfies authentic?</div>
                <CheckStateResult
                    class="font-semibold"
                    :value="selfieAnalysis.isSelfieAuthentic"
                />
            </div>
            <div class="flex-1 flex-col">
                <div>Is this the same person in the Gov ID?</div>
                <CheckStateResult
                    class="font-semibold"
                    :value="selfieAnalysis.selfieMatchGovId"
                />
            </div>
        </div>
        <div class="flex justify-evenly gap-5 pt-4 text-xs font-normal xs:flex-col xs:items-center legacy-md:flex-row">
            <div class="flex-col items-center gap-1 text-center">
                <label>LEFT SIDE</label>
                <div
                    class="flex h-56 w-56 items-center justify-center rounded-full bg-ds-primary-200 text-xxs font-normal text-ds-primary-500"
                >
                    <ImageWithFallback
                        class="h-full w-full rounded-full object-cover"
                        :src="selfieAnalysis.images.left"
                    >
                        <template #fallback>No photo available</template>
                    </ImageWithFallback>
                </div>
            </div>
            <div class="flex-col items-center gap-1 text-center">
                <label>FRONT</label>
                <div
                    class="flex h-56 w-56 items-center justify-center rounded-full bg-ds-primary-200 text-xxs font-normal text-ds-primary-500"
                >
                    <ImageWithFallback
                        class="h-full w-full rounded-full object-cover"
                        :src="selfieAnalysis.images.front"
                    >
                        <template #failure>No photo available</template>
                    </ImageWithFallback>
                </div>
            </div>
            <div class="flex-col items-center gap-1 text-center">
                <label>RIGHT SIDE</label>
                <div
                    class="flex h-56 w-56 items-center justify-center rounded-full bg-ds-primary-200 text-xxs font-normal text-ds-primary-500"
                >
                    <ImageWithFallback
                        class="h-full w-full rounded-full object-cover"
                        :src="selfieAnalysis.images.right"
                    >
                        <template #failure>No photo available</template>
                    </ImageWithFallback>
                </div>
            </div>
        </div>
    </div>
    <div
        v-if="selfieOverallResult.infoList && 'length' in selfieOverallResult.infoList && selfieOverallResult.infoList?.length"
        class="bg-ds-primary-100 px-4"
    >
        <div class="font-bold">Selfie Explanation</div>
        <div class="">
            <CheckErrorList
                :indentation-level="0"
                :value="selfieOverallResult"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { OverallResult, SelfieVerificationAnalysis } from '@/api/interfaces/identity-verification-report.api';
import ImageWithFallback from '../../ImageWithFallback.vue';
import CheckErrorList from '../common/CheckErrorList.vue';
import CheckStateResult from '../common/CheckStateResult.vue';

defineProps<{
    selfieAnalysis: SelfieVerificationAnalysis;
    selfieOverallResult: OverallResult['selfieVerification'];
}>();
</script>
